import React from 'react';
import { Icon } from '@iconify/react';
import { SubscriberData } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';
import { CalendarIcon } from '../../../../components/icons';

interface SubscriberDateCellProps {
  subscriber: SubscriberData;
}

const SubscriberDateCell: React.FC<SubscriberDateCellProps> = ({ subscriber }) => {
  const { t } = useTranslations();

  const getRelativeTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();

    const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    if (days > 0) {
      const template = t('subscribers.timeAgo.daysHours');
      return template.replace('{{days}}', days.toString()).replace('{{hours}}', hours.toString());
    } else if (hours > 0) {
      const template = t('subscribers.timeAgo.hours');
      return template.replace('{{hours}}', hours.toString());
    } else {
      const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
      const template = t('subscribers.timeAgo.minutes');
      return template.replace('{{minutes}}', minutes.toString());
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <CalendarIcon />
        <span className="text-sm text-default-500">{getRelativeTime(subscriber.createdAt)}</span>
      </div>
    </div>
  );
};

export default SubscriberDateCell;
